import { render, staticRenderFns } from "./get-patients-charges.vue?vue&type=template&id=7f14c621&scoped=true"
import script from "./get-patients-charges.vue?vue&type=script&lang=js"
export * from "./get-patients-charges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f14c621",
  null
  
)

export default component.exports